import React from 'react';
import { Link } from 'react-router-dom';

export default function AverageButton({ active = false, to = '/dashboard?focus=average' }) {
  return (
    <Link to={to} className={`tab-btn${active ? ' active' : ''}`}>
      Average
    </Link>
  );
}

export function AveragePanel({ answers, totalQuestions = 0 }) {
  const gradedAnswers = answers.filter((item) => item.grade != null);
  const completedCount = answers.length;
  const averageGradeNum = gradedAnswers.length
    ? gradedAnswers.reduce((sum, item) => sum + Number(item.grade || 0), 0) / gradedAnswers.length
    : 0;
  const averagePercent = Math.round((averageGradeNum / 4) * 100);
  const percentToLetter = (pct) => {
    if (gradedAnswers.length === 0) return '—';
    if (pct >= 90) return 'A';
    if (pct >= 80) return 'B';
    if (pct >= 70) return 'C';
    if (pct >= 60) return 'D';
    return 'F';
  };
  const averageLetter = percentToLetter(averagePercent);

  return (
    <section className="question-card" id="average-panel">
      <div className="question-meta">
        <span className="question-number">Average</span>
        <h2 className="question-title">Average</h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1rem' }}>
        <div className="question-page-summary">
          <div>
            <div style={{ fontWeight: 700, color: 'var(--color-dark)', fontSize: '22px' }}>
              Average: {averagePercent}% / {averageLetter}
            </div>
            <div style={{ fontWeight: 700, color: 'var(--color-dark)', fontSize: '22px' }}>
              Questions Completed: {completedCount} / {totalQuestions}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
